module.exports = __webpack_public_path__ + "img/Weightlifting.cd89a60f.png";